import React from 'react';
import { usePermission } from '../hooks/usePermission';

/**
 * Component to protect routes based on permissions
 * 
 * Usage:
 * <Route path="/finance/*" element={
 *   <RequirePermission module="finance">
 *     <Finance />
 *   </RequirePermission>
 * } />
 */
export default function RequirePermission({ module, level = 'view', children }) {
  const { canView, canEdit, canDelete } = usePermission();

  let hasPermission = false;

  if (level === 'view') {
    hasPermission = canView(module);
  } else if (level === 'edit') {
    hasPermission = canEdit(module);
  } else if (level === 'full') {
    hasPermission = canDelete(module);
  }

  if (!hasPermission) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-gray-800 rounded-lg p-8 text-center">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Access Denied</h2>
          <p className="text-gray-400 mb-6">
            You don't have permission to access this module. Please contact your administrator if you believe this is an error.
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
}
